import React from 'react';
import Footer from './Footer';
import Navigation from './Navigation';

const Terms = () => {
  return (
    <>
        <Navigation/>
        <div className="min-h-screen bg-gray-50 font-sans">
      {/* Vibrant Header Section - Slightly different hue for distinction */}
      <div className="bg-gradient-to-r from-blue-600 via-teal-500 to-emerald-500 py-16 px-4 sm:px-6 lg:px-8 text-center text-white shadow-lg">
        <h1 className="text-4xl font-extrabold tracking-tight sm:text-5xl mb-4 pt-20">
          Terms & Conditions
        </h1>
        <p className="text-lg text-teal-100 max-w-2xl mx-auto">
          Please read these terms carefully before using our service.
        </p>
        <p className="mt-4 text-sm text-teal-50 uppercase tracking-widest font-semibold">
          Last Updated: August 11, 2025
        </p>
      </div>

      {/* Main Content Container */}
      <div className="max-w-4xl mx-auto -mt-10 px-4 sm:px-6 lg:px-8 pb-16 relative z-10">
        <div className="bg-white rounded-2xl shadow-xl p-8 sm:p-12 border border-gray-100">
          
          <div className="prose prose-lg prose-teal max-w-none text-gray-600">
            <p className="lead text-xl text-gray-700 mb-8">
              These Terms and Conditions constitute a legally binding agreement made between you, whether personally or on behalf of an entity (“you”) and Our Company (“we,” “us” or “our”), concerning your access to and use of our website.
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 border-l-4 border-teal-500 pl-4">
                1. Agreement to Terms
              </h2>
              <p>
                By accessing the Site, you confirm that you have read, understood, and agreed to be bound by all of these Terms and Conditions. If you do not agree with all of these terms, then you are expressly prohibited from using the Site and you must discontinue use immediately.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 border-l-4 border-teal-500 pl-4">
                2. Intellectual Property Rights
              </h2>
              <p className="mb-4">
                Unless otherwise indicated, the Site is our proprietary property and all source code, databases, functionality, software, website designs, audio, video, text, photographs, and graphics on the Site (collectively, the “Content”) are owned or controlled by us or licensed to us.
              </p>
              <div className="bg-teal-50 border border-teal-100 p-4 rounded-lg text-sm text-teal-800">
                <strong>Note:</strong> You are granted a limited license to access and use the Site and to download or print a copy of any portion of the Content to which you have properly gained access solely for your personal, non-commercial use.
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 border-l-4 border-teal-500 pl-4">
                3. User Representations
              </h2>
              <p className="mb-4">
                By using the Site, you represent and warrant that:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>All registration information you submit will be true, accurate, current, and complete.</li>
                <li>You have the legal capacity and you agree to comply with these Terms and Conditions.</li>
                <li>You are not a minor in the jurisdiction in which you reside.</li>
                <li>You will not access the Site through automated or non-human means, whether through a bot, script, or otherwise.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 border-l-4 border-teal-500 pl-4">
                4. Prohibited Activities
              </h2>
              <p>
                You may not access or use the Site for any purpose other than that for which we make the Site available. The Site may not be used in connection with any commercial endeavors except those that are specifically endorsed or approved by us.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 border-l-4 border-teal-500 pl-4">
                5. Limitation of Liability
              </h2>
              <p>
                In no event will we or our directors, employees, or agents be liable to you or any third party for any direct, indirect, consequential, exemplary, incidental, special, or punitive damages, including lost profit, lost revenue, loss of data, or other damages arising from your use of the site.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 border-l-4 border-teal-500 pl-4">
                6. Governing Law
              </h2>
              <p>
                These Terms shall be governed by and defined following the laws of [Your Country/State]. You consent to resolve any dispute you have with us exclusively in the competent courts of [Your Jurisdiction].
              </p>
            </section>

          </div>
        </div>
      </div>
    </div>

    <Footer/>
    </>
  );
};

export default Terms;